import { appName } from '@/ui/constants';
import { ContactManagementConfigProvider } from '@juvare/contact-management/ui/providers';
import React from 'react';

export const ContactManagementConfigProviderAnonymous: React.FC<React.PropsWithChildren> = (props) => {
    return <ContactManagementConfigProvider appName={appName}>{props.children}</ContactManagementConfigProvider>;
};
